<template>
  <!-- 精选配置详情页面 -->
  <div class="choicenessDetailPage">
    <!-- <commonvideo :poster="poster" :src="src" :videoData="videoData" @timeupdate="timeupdate" :autoplay="true" :loop="true"></commonvideo>
    <img :src="poster1" alt="" style="width:100%" /> -->
    <div v-if="datas && datas.activityFile" class="activityFileBox">
      <template v-for="item in datas.activityFile" :key="item.id">
        <commonvideo
          v-if="item.type === 'mp4'"
          :poster="poster || ''"
          :src="item.dblclickImage"
          :videoData="videoData"
          @timeupdate="timeupdate"
          :autoplay="false"
          :loop="false"
          :isShowControl="true"
        ></commonvideo>
        <img v-else :src="item.dblclickImage" alt="" style="width:100%;" />
      </template>
    </div>
    <van-divider v-else :style="{ color: '#999', borderColor: '#f5f5f5', padding: '0 16px' }">暂无数据</van-divider>
    <div v-if="routeArr && routeArr.length" class="imgBox">
      <div v-for="item in routeArr" :key="item.path" class="pathCard" @click="jump(item)">
        <img v-if="item.src" :src="item.src" />
        <text class="text">{{ item.text }}</text>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, computed, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getChoiceConfigDetails } from '@/api/choiceness'
import commonvideo from '@/components/common/video'
import { useStore } from 'vuex'

export default {
  name: 'choicenessDetail',
  components: {
    commonvideo
  },
  setup() {
    const router = useRouter()
    let route = useRoute()
    let store = useStore()
    const state = reactive({
      poster1: 'https://www.jiaozhu.xyz/oss/quickMark/aliPayment.jpg',
      poster: '',
      src: 'https://www.jiaozhu.xyz/oss/all/1920x1080_G_628102888_HD_ZH-CN.mp4',
      videoData: { currentTime: 0, duration: 14 },
      id: route.query.id,
      datas: null,
      domain: store.state.staticDomain
    })
    const routeObj = computed(() => {
      let commonStatic = `${state.domain}/mp/staticimg/`
      return {
        planViewFlag: { path: '/planList', src: `${commonStatic}choicenessToPlan.jpg`, event: '线索查看计划', text: '查看致友计划 >' },
        couponViewFlag: { path: '/couponCollection', src: `${commonStatic}choicenessToCoupon.jpg`, event: '线索查看优惠券', text: '前往领券中心 >' },
        tyreViewFlag: { path: '/tyreList', src: `${commonStatic}choicenessTotyre.jpg`, event: '线索查看轮胎', text: '前往购买轮胎 >' },
        oabViewFlag: { path: '/oabCreate', src: `${commonStatic}choicenessToOab.jpg`, event: '线索创建OAB预约', text: '预约维修保养 >' }
      }
    })
    const routeMap = ['planViewFlag', 'couponViewFlag', 'tyreViewFlag', 'oabViewFlag']
    const routeArr = computed(() => {
      return routeMap.reduce((res, flag) => (state.datas && state.datas[flag] === 1 && routeObj.value[flag] ? [...res, routeObj.value[flag]] : [...res]), [])
    })
    const timeupdate = val => {
      // console.log('timeupdate', val)
    }
    const init = async () => {
      let params = { choiceConfigId: state.id }
      try {
        let res = await getChoiceConfigDetails(params)
        state.datas = res
      } catch (e) {
        state.datas = null
      }
    }
    const jump = val => {
      // console.log('jump---->', val)
      const jumpTarget = { ...val, query: { event: val.event, from: 'home' } }
      val && val.path && router.push(jumpTarget)
    }

    onMounted(async () => {
      init()
    })
    // 离开页面清除轮询
    onUnmounted(() => {})
    return {
      ...toRefs(state),
      timeupdate,
      routeArr,
      jump
    }
  }
}
</script>

<style lang="scss" scoped>
.choicenessDetailPage {
  padding: 0px 10px;
  box-sizing: border-box;
  background-color: #ddd;
  font-size: 0;
  padding-bottom: calc(2px + constant(safe-area-inset-bottom));
  padding-bottom: calc(2px + env(safe-area-inset-bottom));
  .activityFileBox img {
    margin-bottom: 0;
  }
  .imgBox {
    padding: 10px 0 10px;
  }
  .pathCard {
    position: relative;
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100px;
    }
    .text {
      position: absolute;
      right: 10px;
      bottom: 10px;
      font-size: 12px;
      color: #fff;
    }
  }
}
</style>
